import * as React from "react";
import { Input, Col, Form, Checkbox, Select } from "antd";

import { FormInstance } from "antd/lib/form";
import { IOrganisationIndex } from "../../../organisations/model/OrganisationIndex";
import TranslationInputField from "../../../core/ui/components/TranslationInputField";
import { IStore } from "../../../core/model/runtime/state/Store";
import FormSection from "../../../core/ui/components/FormSection";

const FormFields = {
  ID: "id",
  NAME: "name",
  INDEX_TYPE_ID: "indexTypeId",
  ORGANISATION_GROUP_ID: "organisationGroupId",
  ORGANISATION_ID: "organisationId",
  VALID: "valid",
  HARMONIZED: "harmonized",
  ORGANISATION_INDEX_LIST: "organisationIndexList",
  PARENT_GROUP: "parentGroup",
  SECOND_GROUP: "secondGroup",
  INDEXES_BY_CATEGORY: "connectedIndexesByCategory"
};

const OrganisationIndexForm = ({
  translate,
  form,
  rowData,
  indexTypeId,
  organisationId,
  groupId,
  store,
  canSelectedIndexBeNonHarmonized,
  connectionCandidatesByCategory,

  toggleConnectedByCategory,
  connectedIndexesByCategory
}: {
  translate: any;
  form: FormInstance;
  rowData?: IOrganisationIndex;
  indexTypeId: number;
  groupId: number;
  organisationId: number;
  store: IStore;
  canSelectedIndexBeNonHarmonized?: boolean;
  connectionCandidatesByCategory?: any[];
  toggleConnectedByCategory?: any;
  connectedIndexesByCategory?: any[];
}) => {
  const { Option } = Select;
  let a =
    connectedIndexesByCategory &&
    connectedIndexesByCategory.map((item) => item.id);
  const getInitialValues = () => {
    if (rowData && Object.keys(rowData).length > 0) {
      if (rowData.nameTranslations.length > 0) {
        return rowData.nameTranslations;
      } else {
        return [
          {
            nameTranslation: rowData.name,
            languageId: store.getState<any>().selectedLanguage.id,
            valid: true
          }
        ];
      }
    } else {
      return [
        {
          nameTranslation: "",
          languageId: store.getState<any>().selectedLanguage.id,
          valid: true
        }
      ];
    }
  };

  form.setFieldsValue({
    organisationGroupId: groupId,
    indexTypeId,
    organisationId,
    nameTranslations: getInitialValues()
  });

  function findParent(group, groupList, data) {
    if (group?.parentId) {
      let g = groupList.find((g) => g.id === group?.parentId);
      if (g) {
        data = data + ` 🡐 ${g?.name}`;
        return findParent(g, groupList, data);
      }
    } else if (group?.organisationIndexCategory) {
      data = data + ` 🡐 ${group?.organisationIndexCategory?.name}`;
    }
    return data;
  }

  function renderOptions(list) {
    return list?.map((index) => {
      let data = index.name;
      if (index.groups) {
        let firstGroup = index.groups.find(
          (g) => g.id === index.organisationGroupId
        );
        data = `${index?.name} 🡐 ${firstGroup?.name}`;
        data = findParent(firstGroup, index.groups, data);
      }
      return (
        <Option key={index.id} value={index.id} title={data} label={data}>
          {data}
        </Option>
      );
    }) || [];
  }

  return (
    <Form
      layout={"vertical"}
      form={form}
      initialValues={{
        nameTranslations: getInitialValues()
      }}
    >
      <Form.Item
        name={FormFields.ID}
        initialValue={rowData?.id}
        style={{ display: "none" }}
      >
        <Input />
      </Form.Item>

      <Col xs={24} sm={24}>
        <Col lg={24} sm={24} xs={24}>
          <TranslationInputField
            translate={translate}
            organisationId={organisationId}
            translationObjectIdFieldName={"organisationIndexId"}
            store={store}
            form={form}
          />
        </Col>
      </Col>
      <Col xs={24} sm={24}>
        <Form.Item
          name={FormFields.INDEX_TYPE_ID}
          initialValue={rowData?.indexTypeId ?? indexTypeId}
          style={{ display: "none" }}
        >
          <Input />
        </Form.Item>
        <Form.Item
          name={FormFields.ORGANISATION_ID}
          initialValue={rowData?.organisationId ?? organisationId}
          style={{ display: "none" }}
        >
          <Input />
        </Form.Item>
        <Form.Item
          name={FormFields.VALID}
          initialValue={rowData?.valid ?? true}
          style={{ display: "none" }}
        >
          <Input />
        </Form.Item>
        <Form.Item
          name={FormFields.ORGANISATION_GROUP_ID}
          initialValue={rowData?.organisationGroupId ?? groupId}
          style={{ display: "none" }}
        >
          <Input />
        </Form.Item>

        <FormSection
          title={translate("editors.case_law_documents.classification")}
          subtitle={translate(
            "editors.case_law_documents.sections.index_subtitle"
          )}
        >
          <Form.Item
            label={translate("editors.case_decisions.index_data")}
            name={FormFields.INDEXES_BY_CATEGORY}
            shouldUpdate
            initialValue={
              connectedIndexesByCategory
                ? connectedIndexesByCategory.map((item) => item.id)
                : []
            }
          >
            <Select
              mode="multiple"
              allowClear
              showSearch
              optionFilterProp="children"
              className={"png-tagbox"}
              onChange={toggleConnectedByCategory}
            >
              {renderOptions(connectionCandidatesByCategory)}
            </Select>
          </Form.Item>
        </FormSection>
      </Col>
      {canSelectedIndexBeNonHarmonized && (
        <Col xs={24} sm={24}>
          <Form.Item
            label={translate("editors.organisation_indexes.harmonized")}
            className={"png-form-item-horizontal-checkbox mb-0"}
            name={FormFields.HARMONIZED}
            valuePropName={"checked"}
            initialValue={rowData?.harmonized ?? true}
          >
            <Checkbox />
          </Form.Item>
        </Col>
      )}
    </Form>
  );
};

export default OrganisationIndexForm;
